module.exports = __webpack_public_path__ + "static/media/puzzle.3322fca5.png";